import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import elementUI from 'element-ui'
import VEmojiPicker from "v-emoji-picker"
Vue.use(VEmojiPicker);
// 高德地图
import AmapVue from '@amap/amap-vue';
 
AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
AmapVue.config.key = '3b57b07f4551f49e92ce9ea76993934a';
AmapVue.config.plugins = [
  'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
  'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.DistrictSearch', 'AMap.CircleMarker', 'AMap.Polyline'
];
Vue.use(AmapVue);
window._AMapSecurityConfig = {
  securityJsCode:'666c8bc0d401cb1b4268bcc54c6e1848',
};
Vue.use(elementUI)

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})
